<!-- Small Icons -->
<span [innerHTML]="icon" [class]="class"></span>
